import { InjectionToken } from 'tsyringe';

export type LogSeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export interface ILogService {
  captureError(error: Error, extra?: Record<string, unknown>, tags?: Record<string, string>): void;
  captureText(
    text: string,
    severity?: LogSeverityLevel,
    extra?: Record<string, unknown>,
    tags?: Record<string, string>,
  ): void;
  clearAllTags(): void;
  clearTag(key: string): void;
  setTag(key: string, value: string): void;
  setTags(tags: Record<string, string>): void;
}

export const LOG_SERVICE: InjectionToken<ILogService> = 'LogService';
